module.exports = __webpack_public_path__ + "static/media/toolbar-zoom-normal.f638392c.svg";